import React, { useState, useEffect, useMemo, useRef } from 'react'
import { Container, Row, Col, Button, Badge } from 'react-bootstrap'
import {
  LuGraduationCap,
  LuUsers,
  LuBookOpen,
  LuUserPlus,
  LuClipboardList,
  LuSchool,
  LuWallet,
} from 'react-icons/lu'
import {
  BsMegaphoneFill,
  BsExclamationTriangleFill,
  BsCheckCircleFill,
  BsFileEarmarkTextFill,
} from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'
import { Doughnut, Bar, Line } from 'react-chartjs-2'
import Cookies from 'js-cookie'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Filler,
} from 'chart.js'
import axios from 'axios'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL, BASE_URL_Upload, CLOUD_BASE_URL} from './commonComponents/ApiEndpoints'
import { useSidebar } from './SidebarContext'
import { useAuth } from './AuthContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'
import {
  fetchTopAnnouncements,
  getAnnouncementErrorMessage,
  parseAnnouncementListResponse,
} from './commonComponents/announcementApi'

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Filler,
)

export default function Dashboard() {
  const navigate = useNavigate()
  const hasFetchedRef=useRef(false)
  const hasFeesFetchedRef =useRef(false)
  const hasAttendanceFetchedRef = useRef(false)
  const hasRecentActivitiesFetchedRef = useRef(false)
  const hasAnnouncementsFetchedRef = useRef(false)
  const [instituteName, setInstitutename] = useState()
  const [instituteNameTeacher, setinstituteNameTeacher] = useState()
  const [instituteId, setInstituteId] = useState()
  const [logoError, setLogoError] = useState(false)
  const [countByCourse, setCountByCourse] = useState([])
  const [dashboardData, setDashboardData] = useState({})
  const [feesByMonths, setFeesByMonths] = useState([])
  const [attendanceData, setAttendanceData] = useState([])
  const [monthlyAdmissions, setMonthlyAdmissions] = useState([])
  const [recentActivities, setRecentActivities] = useState([])
  const [totalFeesCollected, setTotalFeesCollected] = useState(0)
  const [topAnnouncements, setTopAnnouncements] = useState([])
  const [announcementsLoading, setAnnouncementsLoading] = useState(true)
  const [notificationCount, setNotificationCount] = useState(3)
  const { isCollapsed } = useSidebar()
  const { logo, name, id } = useInstitute();
  const { logout } = useAuth()

  // Get institute name and ID from cookies
  useEffect(() => {
    const storedInstituteName = Cookies.get('institute_name')
    const storedInstituteId = Cookies.get('institute_id')
    const instituteConfirmed = sessionStorage.getItem('institute_confirmed')

    // Check if institute_id exists but no sessionStorage confirmation (stale cookie)
    if (storedInstituteId && !instituteConfirmed) {
      console.warn('⚠️ Stale institute_id cookie detected in Dashboard. Clearing and redirecting.')
      Cookies.remove('institute_id')
      Cookies.remove('institute_name')
      Cookies.remove('institute_logo')
      sessionStorage.removeItem('institute_confirmed')
      sessionStorage.removeItem('institute_confirmed_timestamp')
      window.location.replace('/LoginSignup')
      return
    }

    // Check if institute_id exists, if not redirect to LoginSignup immediately
    if (!storedInstituteId) {
      console.warn('No institute selected. Redirecting to LoginSignup.')
      // Use window.location for immediate redirect that can't be blocked
      window.location.replace('/LoginSignup')
      return
    }

    if (storedInstituteName) {
      console.log('Institute name:', storedInstituteName)
      setInstitutename(storedInstituteName)
    }

    if (storedInstituteId) {
      console.log('Institute ID:', storedInstituteId)
      setInstituteId(storedInstituteId)
    }
  }, [])

  useEffect(() => {
    if (hasAnnouncementsFetchedRef.current) return
    hasAnnouncementsFetchedRef.current = true

    let cancelled = false
    const fetchDashboardAnnouncements = async () => {
      setAnnouncementsLoading(true)
      try {
        const response = await Promise.race([
          fetchTopAnnouncements(),
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error('Announcements request timeout')), 12000),
          ),
        ])
        if (cancelled) return
        const rows = parseAnnouncementListResponse(response)
        setTopAnnouncements((rows || []).slice(0, 5))
      } catch (error) {
        if (!cancelled) {
          setTopAnnouncements([])
          toast.error(getAnnouncementErrorMessage(error, navigate))
        }
      } finally {
        if (!cancelled) setAnnouncementsLoading(false)
      }
    }

    fetchDashboardAnnouncements()
    return () => {
      cancelled = true
      // StrictMode-safe: allow a fresh fetch on effect remount cycle in dev.
      hasAnnouncementsFetchedRef.current = false
    }
  }, [navigate])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteIDxashdfasdfldslkdfasldkflasdflk', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    
    if(!institueId || hasFetchedRef.current) return
    hasFetchedRef.current = true

 
    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        'institute-id': Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+'/dashboard',
          { headers },
        )

        console.log('Students response: ', response.data.data)

        setDashboardData(response.data.data)
        setCountByCourse(response.data.data.students_by_course || [])
        console.log('Course count data:', response.data.data.students_by_course)

        // setFilteredData(response.data.data) // ✅ FIXED: show data in table
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [instituteId])

     useEffect(()=>{
      const fetchInstituteNameCookie = async ()=>{
        const instituteNameCookie = await ApiEndpoints.getAllInstitutes()
        console.log("instituteNameCookie", instituteNameCookie.data.data)

        const cookieInstituteId = Cookies.get("institute_id")
        console.log("cookieInstituteId", cookieInstituteId)

        const allInstitutesData = instituteNameCookie.data.data

        const matchedInstituteName = allInstitutesData.find((item)=>item.institute_id == cookieInstituteId)

        console.log("matchedInstituteName", matchedInstituteName.name)

        setInstitutename(matchedInstituteName.name)
      }
      fetchInstituteNameCookie()
    },[])

  useEffect(() => {
    if( hasFeesFetchedRef.current) return
    hasFeesFetchedRef.current = true
    const fetchMonthFees = async () => {
      const institueId = Cookies.get('institute_id')
      const userCookie = Cookies.get('user')
      let token = null

      if (userCookie) {
        try {
          const user = JSON.parse(userCookie)
          token = user.token
        } catch (err) {
          console.error('Failed to parse user cookie', err)
        }
      }

      if(!institueId) return

      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId),
        }

        const response = await axios.get(
          BASE_URL+'/dashboard/fees-by-months',
          { headers },
        )

        console.log('Fees by month response: ', response.data.data)

        setFeesByMonths(response.data.data)
      } catch (error) {
        console.error(error.response?.data?.message || 'Something went wrong')
      }
    }
    fetchMonthFees()
  }, [])

  // Fetch attendance data for overview
  // useEffect(() => {
  //   if (hasAttendanceFetchedRef.current) return
  //   hasAttendanceFetchedRef.current = true
    
  //   const fetchAttendanceData = async () => {
  //     const institueId = Cookies.get('institute_id')
  //     const userCookie = Cookies.get('user')
  //     let token = null

  //     if (userCookie) {
  //       try {
  //         const user = JSON.parse(userCookie)
  //         token = user.token
  //       } catch (err) {
  //         console.error('Failed to parse user cookie', err)
  //       }
  //     }

  //     if (!institueId) return

  //     try {
  //       const headers = {
  //         'Content-Type': 'application/json',
  //         Authorization: `Bearer ${token}`,
  //         'institute-Id': Number(institueId),
  //       }

  //       // Get last 7 days attendance
  //       const today = new Date()
  //       const sevenDaysAgo = new Date(today)
  //       sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)

  //       const response = await axios.post(
  //         BASE_URL + '/get/attendance',
  //         {
  //           from_date: sevenDaysAgo.toISOString().split('T')[0],
  //           to_date: today.toISOString().split('T')[0],
  //         },
  //         { headers }
  //       )

  //       if (response.data?.data) {
  //         setAttendanceData(response.data.data)
  //       }
  //     } catch (error) {
  //       console.error('Failed to fetch attendance:', error.response?.data?.message || 'Something went wrong')
  //     }
  //   }
  //   fetchAttendanceData()
  // }, [])

  // Fetch recent activities (students and fee payments)
  useEffect(() => {
    if (hasRecentActivitiesFetchedRef.current) return
    hasRecentActivitiesFetchedRef.current = true
    
    const fetchRecentActivities = async () => {
      const institueId = Cookies.get('institute_id')
      const userCookie = Cookies.get('user')
      let token = null

      if (userCookie) {
        try {
          const user = JSON.parse(userCookie)
          token = user.token
        } catch (err) {
          console.error('Failed to parse user cookie', err)
        }
      }

      if (!institueId) return

      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId),
        }

        // Fetch recent students
        const studentsResponse = await axios.get(BASE_URL + '/student/all', { headers })
        const students = studentsResponse.data?.data || []
        
        // Fetch fee collection summary
        const feesResponse = await axios.get(BASE_URL + '/fee-collection', { headers })
        const feeCollection = feesResponse.data?.data || {}
        setTotalFeesCollected(parseFloat(feeCollection.yearly_collection) || 0)

        // Process recent activities
        const activities = []
        
        // Add recent student registrations (last 10)
        const recentStudents = students
          .sort((a, b) => new Date(b.created_at || b.createdAt || 0) - new Date(a.created_at || a.createdAt || 0))
          .slice(0, 5)
          .map(student => ({
            type: 'registration',
            title: `New student registered: ${student.first_name || ''} ${student.last_name || ''}`,
            date: student.created_at || student.createdAt,
            icon: LuUserPlus,
          }))

        activities.push(...recentStudents)
        activities.sort((a, b) => new Date(b.date) - new Date(a.date))
        
        setRecentActivities(activities.slice(0, 10))

        // Calculate monthly admissions
        const monthlyData = {}
        students.forEach(student => {
          const date = new Date(student.created_at || student.createdAt || Date.now())
          const monthKey = `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`
          monthlyData[monthKey] = (monthlyData[monthKey] || 0) + 1
        })

        const lastSixMonths = []
        const now = new Date()
        for (let i = 5; i >= 0; i--) {
          const date = new Date(now.getFullYear(), now.getMonth() - i, 1)
          const monthKey = `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`
          lastSixMonths.push({
            month: monthKey,
            count: monthlyData[monthKey] || 0,
          })
        }
        setMonthlyAdmissions(lastSixMonths)
      } catch (error) {
        console.error('Failed to fetch recent activities:', error.response?.data?.message || 'Something went wrong')
      }
    }
    fetchRecentActivities()
  }, [])
  const studentData = {
    labels: ['Active', 'Inactive'],
    datasets: [
      {
        data: dashboardData?.students_by_status
          ? [
              dashboardData.students_by_status.active,
              dashboardData.students_by_status.inactive,
            ]
          : [0, 0],
        backgroundColor: ['#223843', '#10B981'],
        borderColor: '#ffffff',
        borderWidth: 3,
        hoverOffset: 4,
      },
    ],
  }
  const activeStudentCount = Number(dashboardData?.students_by_status?.active) || 0
  const inactiveStudentCount = Number(dashboardData?.students_by_status?.inactive) || 0
  const hasStudentDistributionData = activeStudentCount + inactiveStudentCount > 0
  // const courseChartData = {
  //   labels: courseLabels,
  //   datasets: [
  //     {
  //       label: 'Total Students',
  //       data: courseData,
  //       backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'], // Add more colors as needed
  //     },
  //   ],
  // }

  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )

  const courseChartData = useMemo(() => {
    // Sort courses by total students (descending)
    const sortedCourses = [...countByCourse].sort(
      (a, b) => (b.total_students || 0) - (a.total_students || 0),
    )

    // On mobile, show top courses; on desktop, show all
    const namedCourses = sortedCourses.filter((course) => String(course?.course_name || '').trim())
    const coursesToShow = isMobile
      ? namedCourses.slice(0, Math.min(10, namedCourses.length))
      : namedCourses

    const courseLabels = coursesToShow.map((course) => course.course_name)
    const courseData = coursesToShow.map((course) => course.total_students)

    const colors = ['#223843', '#10B981', '#14B8A6', '#F59E0B', '#F97316', '#8B5CF6']
    const backgroundColor = courseData.map((_, index) => colors[index % colors.length])

    return {
      labels: courseLabels,
      datasets: [
        {
          label: 'Total Students',
          data: courseData,
          backgroundColor: backgroundColor,
          borderRadius: 4,
          borderSkipped: 'start',
          barPercentage: 0.72,
          categoryPercentage: 0.78,
          maxBarThickness: 22,
        },
      ],
    }
  }, [countByCourse, isMobile])

  const courseBarLabelPlugin = useMemo(() => ({
    id: 'courseBarLabels',
    afterDatasetsDraw(chart) {
      const { ctx } = chart
      const meta = chart.getDatasetMeta(0)
      const values = chart.data.datasets[0]?.data || []
      ctx.save()
      ctx.font = '600 12px Inter, system-ui, sans-serif'
      ctx.textBaseline = 'middle'
      meta.data.forEach((bar, index) => {
        const value = values[index]
        if (value === undefined || value === null) return
        const label = String(value)
        const textWidth = ctx.measureText(label).width
        const barWidth = Math.abs(bar.x - bar.base)
        if (barWidth > textWidth + 16) {
          ctx.fillStyle = '#ffffff'
          ctx.textAlign = 'right'
          ctx.fillText(label, bar.x - 8, bar.y)
        } else {
          ctx.fillStyle = '#223843'
          ctx.textAlign = 'left'
          ctx.fillText(label, bar.x + 6, bar.y)
        }
      })
      ctx.restore()
    },
  }), [])

  const courseChartOptions = useMemo(() => {
    const maxStudents = Math.max(0, ...(courseChartData.datasets[0]?.data || [0]))
    return {
      indexAxis: 'y',
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: { top: 4, right: 28, bottom: 0, left: 0 },
      },
      plugins: {
        legend: { display: false },
        tooltip: {
          backgroundColor: '#223843',
          padding: 10,
          titleFont: { size: 13, weight: '600' },
          bodyFont: { size: 12 },
          cornerRadius: 6,
          callbacks: {
            label: (context) => ` ${context.parsed.x} students`,
          },
        },
      },
      scales: {
        x: {
          beginAtZero: true,
          max: Math.max(maxStudents + 1, 1),
          border: { display: false },
          grid: {
            color: '#F3F4F6',
            drawTicks: false,
          },
          ticks: {
            font: { size: 11 },
            color: '#9ca3af',
            precision: 0,
            padding: 8,
            maxTicksLimit: 6,
          },
        },
        y: {
          offset: true,
          border: { display: false },
          grid: { display: false, drawTicks: false },
          ticks: {
            font: { size: isMobile ? 12 : 13, weight: '500' },
            color: '#374151',
            autoSkip: false,
            padding: 6,
          },
        },
      },
    }
  }, [isMobile, courseChartData])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        /**
         * Sidebar width:
         * - Expanded: 245px  (inline style)
         * - Collapsed: 85px (.sidebar-collapsed CSS with !important)
         */
        const expandedWidth = 245
        const collapsedWidth = 85
        const overlap = 40

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth - overlap}px`
            : `${expandedWidth - overlap}px`,
        )
      } else {
        // On mobile, sidebar becomes off-canvas, so no left offset is needed
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    // Set initial margin and mobile flag
    handleResize()

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const getLastSixMonths = () => {
    const months = []
    const now = new Date()
    for (let i = 5; i >= 0; i--) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1) // 1 represents the first day
      const monthName = date.toLocaleString('default', { month: 'short' })

      // .push() method used to add one or more elements to the end of an array.
      months.push(`${monthName} ${date.getFullYear()}`)
    }
    return months
  }

  const labels = getLastSixMonths()

  const feesMap = feesByMonths.reduce((acc, item) => {
    const date = new Date(item.month)
    const key =
      date.toLocaleString('default', { month: 'short' }) +
      ' ' +
      date.getFullYear()
    acc[key] = (acc[key] || 0) + item.amount
    return acc
  }, {})

  // Create data aligned with last 6 months
  const feesDataPoints = labels.map((month) => feesMap[month] || 0)
  const hasFeesCollectionData = feesDataPoints.some((amount) => Number(amount) > 0)

  // Attendance overview chart data (last 7 days)
  const attendanceChartData = useMemo(() => {
    const last7Days = []
    const attendanceMap = {}
    
    // Process attendance data
    attendanceData.forEach(record => {
      const date = new Date(record.date || record.attendance_date)
      const dateKey = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
      
      if (!attendanceMap[dateKey]) {
        attendanceMap[dateKey] = { present: 0, absent: 0 }
      }
      
      if (record.status === 'present' || record.is_present) {
        attendanceMap[dateKey].present++
      } else {
        attendanceMap[dateKey].absent++
      }
    })

    // Generate last 7 days labels
    for (let i = 6; i >= 0; i--) {
      const date = new Date()
      date.setDate(date.getDate() - i)
      const dateKey = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
      last7Days.push(dateKey)
    }

    return {
      labels: last7Days,
      datasets: [
        {
          label: 'Present',
          data: last7Days.map(day => attendanceMap[day]?.present || 0),
          borderColor: '#10B981',
          backgroundColor: 'rgba(16, 185, 129, 0.08)',
          tension: 0.4,
          fill: true,
          borderWidth: 2,
        },
        {
          label: 'Absent',
          data: last7Days.map(day => attendanceMap[day]?.absent || 0),
          borderColor: '#223843',
          backgroundColor: 'rgba(37, 99, 235, 0.08)',
          tension: 0.4,
          fill: true,
          borderWidth: 2,
        },
      ],
    }
  }, [attendanceData])

  // Monthly admissions chart data
  const monthlyAdmissionsChartData = useMemo(() => {
    return {
      labels: monthlyAdmissions.map(item => item.month),
      datasets: [
        {
          label: 'New Admissions',
          data: monthlyAdmissions.map(item => item.count),
          borderColor: '#223843',
          backgroundColor: 'rgba(37, 99, 235, 0.08)',
          tension: 0.4,
          fill: true,
          borderWidth: 2,
        },
      ],
    }
  }, [monthlyAdmissions])

  const data = {
    labels,
    datasets: [
        {
          label: 'Fees Collected (₹)',
          data: feesDataPoints,
          borderColor: '#223843',
          backgroundColor: 'rgba(34, 56, 67, 0.12)',
          pointBackgroundColor: '#223843',
          pointBorderColor: '#ffffff',
          pointBorderWidth: 2,
          pointRadius: 4,
          pointHoverRadius: 5,
          borderWidth: 2,
          tension: 0.35,
          fill: true,
        },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: '#223843',
        padding: 10,
        titleFont: { size: 13, weight: '600' },
        bodyFont: { size: 12 },
        cornerRadius: 6,
        callbacks: {
          label: (context) => `₹ ${context.parsed.y.toLocaleString('en-IN')}`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: '#F3F4F6',
          drawBorder: false,
        },
        ticks: {
          callback: (value) => `₹${Number(value).toLocaleString('en-IN')}`,
          font: { size: 11 },
          color: '#6b7280',
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: { size: 11 },
          color: '#6b7280',
        },
      },
    },
  }

  // Helper function to calculate time ago
  const getTimeAgo = (date) => {
    if (!date) return 'Just now'
    const now = new Date()
    const past = new Date(date)
    const diffInSeconds = Math.floor((now - past) / 1000)
    
    if (diffInSeconds < 60) return 'Just now'
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} minutes ago`
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`
    if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)} days ago`
    
    return past.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  }

  const getAnnouncementId = (announcement) => announcement?.id ?? announcement?.announcement_id

  const getPriorityMeta = (priority) => {
    const value = String(priority || '').toLowerCase()
    if (value === 'high') {
      return {
        label: 'High',
        bg: '#FEE2E2',
        color: '#B91C1C',
        icon: <BsExclamationTriangleFill size={12} />,
      }
    }
    if (value === 'mid') {
      return {
        label: 'Mid',
        bg: '#FEF3C7',
        color: '#92400E',
        icon: <BsMegaphoneFill size={12} />,
      }
    }
    return {
      label: 'Low',
      bg: '#E5E7EB',
      color: '#374151',
      icon: <BsFileEarmarkTextFill size={12} />,
    }
  }

  const getStatusMeta = (status) => {
    const value = String(status || '').toLowerCase()
    if (value === 'published') {
      return {
        label: 'Published',
        bg: '#DCFCE7',
        color: '#166534',
        icon: <BsCheckCircleFill size={12} />,
      }
    }
    return {
      label: status || 'Draft',
      bg: '#F3F4F6',
      color: '#374151',
      icon: <BsFileEarmarkTextFill size={12} />,
    }
  }

  const truncateAnnouncementMessage = (text, len = 90) => {
    if (!text) return 'No message provided.'
    const value = String(text).trim()
    return value.length <= len ? value : `${value.slice(0, len)}...`
  }

  const totalStudents =
    (dashboardData?.students_by_status?.active || 0) +
    (dashboardData?.students_by_status?.inactive || 0)
  const convertedEnquiries = dashboardData?.enquiries_by_status?.converted || 0
  const pendingEnquiries = dashboardData?.enquiries_by_status?.pending || 0
  const courseChartHeight = Math.max(160, (courseChartData.labels?.length || 0) * 46)

  const statCards = [
    {
      key: 'teachers',
      label: 'Total Teachers',
      value: dashboardData?.total_teachers || 0,
      icon: LuUsers,
      accent: '#14B8A6',
      action: 'View Teachers',
      path: '/TeacherList',
    },
    {
      key: 'courses',
      label: 'Total Courses',
      value: dashboardData?.total_courses || 0,
      icon: LuBookOpen,
      accent: '#10B981',
      action: 'View Courses',
      path: '/AddCourse',
    },
    {
      key: 'classes',
      label: 'Total Classes',
      value: dashboardData?.total_classes || 0,
      icon: LuSchool,
      accent: '#F97316',
      action: 'View Classes',
      path: '/AddClass',
    },
    {
      key: 'fees',
      label: 'Total Fees Collected',
      value: `₹${totalFeesCollected.toLocaleString('en-IN')}`,
      icon: LuWallet,
      accent: '#223843',
      action: 'View Fees',
      path: '/FeeCollection',
    },
    {
      key: 'students',
      label: 'Active Students',
      value: dashboardData?.students_by_status?.active || 0,
      meta: `Total Students: ${totalStudents}  ·  Inactive: ${dashboardData?.students_by_status?.inactive || 0}`,
      icon: LuGraduationCap,
      accent: '#F59E0B',
      action: 'View Students',
      path: '/students',
    },
    {
      key: 'enquiries',
      label: 'Active Enquiries',
      value: convertedEnquiries,
      meta: `Converted: ${convertedEnquiries + pendingEnquiries}  ·  Pending: ${pendingEnquiries}`,
      icon: LuClipboardList,
      accent: '#8B5CF6',
      action: 'View Enquiries',
      path: '/EnquiryForm',
    },
  ]

  return (
    <>
      <style>
        {`
          .dash-page {
            background: #F3F4F6;
            min-height: 100vh;
          }
          .dash-header {
            background: #ffffff;
            border-bottom: 1px solid #D1D3D4;
            padding: 14px 28px 14px 68px;
          }
          .dash-logo {
            width: 40px;
            height: 40px;
            border-radius: 10px;
            overflow: hidden;
            background: #223843;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
          }
          .dash-stats {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 16px;
          }
          .dash-stat {
            background: #ffffff;
            border: 1px solid #D1D3D4;
            border-radius: 12px;
            padding: 16px 16px 14px;
            display: flex;
            flex-direction: column;
            min-height: 148px;
            text-align: left;
            box-shadow: 0 1px 2px rgba(34, 56, 67, 0.04);
            transition: transform 0.22s ease, box-shadow 0.22s ease;
          }
          .dash-stat:hover {
            transform: translateY(-6px);
            box-shadow: 0 12px 24px rgba(34, 56, 67, 0.12);
          }
          .dash-stat-top {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 12px;
          }
          .dash-stat-icon {
            width: 36px;
            height: 36px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
          }
          .dash-stat-label {
            font-size: 13px;
            font-weight: 600;
            color: #6b7280;
            font-family: Inter, system-ui, sans-serif;
            margin: 0;
          }
          .dash-stat-value {
            margin: 10px 0 0;
            font-size: 28px;
            line-height: 1.1;
            font-weight: 700;
            color: #223843;
            font-family: Inter, system-ui, sans-serif;
            letter-spacing: -0.02em;
            word-break: break-word;
          }
          .dash-stat-meta {
            margin: 8px 0 0;
            font-size: 12px;
            line-height: 1.4;
            color: #6b7280;
            font-family: Inter, system-ui, sans-serif;
          }
          .dash-stat-action {
            margin-top: auto;
            padding-top: 12px;
            background: none;
            border: none;
            padding-left: 0;
            font-size: 13px;
            font-weight: 600;
            font-family: Inter, system-ui, sans-serif;
            cursor: pointer;
            text-align: left;
          }
          .dash-stat-action:hover {
            text-decoration: underline;
          }
          .dash-panel {
            background: #ffffff;
            border: 1px solid #D1D3D4;
            border-radius: 12px;
            box-shadow: 0 1px 2px rgba(34, 56, 67, 0.04);
          }
          .dash-panel-title {
            margin: 0;
            color: #223843;
            font-size: 15px;
            font-weight: 600;
            font-family: Inter, system-ui, sans-serif;
          }
          .dash-announce {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }
          .dash-announce-row {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 16px;
            padding: 12px 14px;
            border: 1px solid #E5E7EB;
            border-left-width: 3px;
            border-radius: 8px;
            background: #ffffff;
            text-align: left;
          }
          .dash-announce-row.is-link {
            cursor: pointer;
          }
          .dash-announce-row.is-link:hover {
            background: #F9FAFB;
          }
          .dash-empty {
            color: #6b7280;
            font-size: 13px;
            font-family: Inter, system-ui, sans-serif;
            text-align: center;
            padding: 28px 12px;
          }
          .dash-empty p {
            margin: 0;
          }
          .dash-empty .dash-empty-sub {
            margin-top: 4px;
            color: #9ca3af;
            font-size: 12px;
          }
          .dash-doughnut-wrap {
            position: relative;
            height: 220px;
            max-width: 220px;
            margin: 0 auto;
          }
          .dash-doughnut-center {
            position: absolute;
            inset: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            pointer-events: none;
          }
          .dash-doughnut-center strong {
            font-size: 22px;
            color: #223843;
            line-height: 1;
            font-family: Inter, system-ui, sans-serif;
          }
          .dash-doughnut-center span {
            margin-top: 4px;
            font-size: 11px;
            color: #6b7280;
            font-family: Inter, system-ui, sans-serif;
          }
          .dash-legend {
            display: flex;
            flex-wrap: wrap;
            gap: 14px;
            justify-content: center;
            margin-top: 8px;
          }
          .dash-legend-item {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 13px;
            color: #374151;
            font-family: Inter, system-ui, sans-serif;
          }
          .dash-swatch {
            width: 10px;
            height: 10px;
            border-radius: 2px;
          }
          @media (max-width: 991px) {
            .dash-stats {
              grid-template-columns: repeat(2, minmax(0, 1fr));
            }
          }
          @media (max-width: 768px) {
            body, html {
              overflow-x: hidden !important;
              width: 100% !important;
              max-width: 100vw !important;
            }
            .dash-header {
              padding: 12px 16px;
            }
            .dash-stats {
              grid-template-columns: 1fr;
            }
            .dash-announce-row {
              flex-direction: column;
            }
            .dash-stat-value {
              font-size: 24px;
            }
          }
        `}
      </style>
      <div
        className="dash-page"
        style={{
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
          <div className="dash-header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-3" style={{ flex: 1, minWidth: 0 }}>
              <div className="dash-logo">
                {!logoError ? (
                  <img
                    src={logo}
                    alt="School Logo"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap style={{ fontSize: '20px', color: 'white' }} />
                )}
              </div>
              <div style={{ minWidth: 0 }}>
                <h3
                  className="m-0 fw-bold"
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: isMobile ? '16px' : 'clamp(18px, 2.5vw, 22px)',
                    color: '#223843',
                    lineHeight: '1.2',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  {instituteName
                    ? `${instituteName} Dashboard`
                    : 'School Management Dashboard'}
                </h3>
                <p className="m-0 mt-0 text-start" style={{ fontSize: isMobile ? '12px' : '13px', color: '#6b7280' }}>
                  Welcome back! Here's what's happening today.
                </p>
              </div>
            </div>
            {!isMobile && (
              <ProfileDropdown logout={logout} notificationCount={notificationCount} showNotifications={true} />
            )}
          </div>

          <Container
            fluid
            className="py-4"
            style={{
              paddingLeft: isMobile ? '16px' : '68px',
              paddingRight: '28px',
            }}
          >
            <div className="dash-panel mb-4">
              <div className="p-3 p-md-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <BsMegaphoneFill style={{ color: '#B91C1C' }} />
                    <h5 className="dash-panel-title">Recent Announcement</h5>
                  </div>
                  {topAnnouncements.length > 0 ? (
                    <Button
                      variant="outline-dark"
                      size="sm"
                      onClick={() => navigate('/announcements')}
                      style={{
                        borderRadius: '8px',
                        fontWeight: 600,
                        fontSize: '12px',
                        borderColor: '#D1D3D4',
                        color: '#223843',
                        background: '#ffffff',
                      }}
                    >
                      View All
                    </Button>
                  ) : null}
                </div>

                {announcementsLoading ? (
                  <div className="dash-empty" style={{ textAlign: 'left', padding: '8px 0' }}>Loading announcements...</div>
                ) : topAnnouncements.length === 0 ? (
                  <div className="dash-empty" style={{ textAlign: 'left', padding: '8px 0' }}>
                    No recent announcements available.
                  </div>
                ) : (
                  <div className="dash-announce">
                    {topAnnouncements.map((announcement, index) => {
                      const id = getAnnouncementId(announcement)
                      const priorityMeta = getPriorityMeta(announcement?.priority)
                      const statusMeta = getStatusMeta(announcement?.status)
                      const title = announcement?.title || 'Untitled announcement'
                      const message = announcement?.message ?? announcement?.description ?? ''

                      return (
                        <div
                          key={id ?? index}
                          className={`dash-announce-row${id ? ' is-link' : ''}`}
                          style={{ borderLeftColor: priorityMeta.color }}
                          onClick={() => {
                            if (id) navigate(`/announcement/view/${id}`)
                          }}
                          role={id ? 'button' : undefined}
                          tabIndex={id ? 0 : -1}
                          onKeyDown={(event) => {
                            if (id && (event.key === 'Enter' || event.key === ' ')) {
                              event.preventDefault()
                              navigate(`/announcement/view/${id}`)
                            }
                          }}
                        >
                          <div style={{ minWidth: 0, flex: 1 }}>
                            <div className="fw-semibold" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                              {title}
                            </div>
                            <div style={{ color: '#6B7280', fontSize: '13px', marginTop: '4px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                              {truncateAnnouncementMessage(message)}
                            </div>
                          </div>
                          <div className="d-flex align-items-center gap-2 flex-wrap">
                            <Badge
                              bg="white"
                              style={{
                                backgroundColor: priorityMeta.bg,
                                color: priorityMeta.color,
                                borderRadius: '999px',
                                fontWeight: 600,
                                padding: '6px 10px',
                              }}
                            >
                              <span className="d-inline-flex align-items-center gap-1">
                                {priorityMeta.icon}
                                {priorityMeta.label}
                              </span>
                            </Badge>
                            <Badge
                              bg="white"
                              style={{
                                backgroundColor: statusMeta.bg,
                                color: statusMeta.color,
                                borderRadius: '999px',
                                fontWeight: 600,
                                padding: '6px 10px',
                              }}
                            >
                              <span className="d-inline-flex align-items-center gap-1">
                                {statusMeta.icon}
                                {statusMeta.label}
                              </span>
                            </Badge>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                )}
              </div>
            </div>

            <div className="dash-stats mb-4">
              {statCards.map((card) => {
                const Icon = card.icon
                return (
                  <article key={card.key} className="dash-stat">
                    <div className="dash-stat-top">
                      <p className="dash-stat-label">{card.label}</p>
                      <div className="dash-stat-icon" style={{ background: `${card.accent}18`, color: card.accent }}>
                        <Icon size={18} />
                      </div>
                    </div>
                    <p className="dash-stat-value">{card.value}</p>
                    {card.meta ? <p className="dash-stat-meta">{card.meta}</p> : null}
                    <button
                      type="button"
                      className="dash-stat-action"
                      style={{ color: card.accent }}
                      onClick={() => navigate(card.path)}
                    >
                      {card.action}
                    </button>
                  </article>
                )
              })}
            </div>

            <Row className="g-3 mb-3">
              <Col xs={12} lg={5}>
                <div className="dash-panel h-100">
                  <div className="p-3 p-md-4">
                    <h5 className="dash-panel-title mb-3">Student Distribution</h5>
                    {hasStudentDistributionData ? (
                      <>
                        <div className="dash-doughnut-wrap">
                          <Doughnut
                            data={studentData}
                            options={{
                              cutout: '68%',
                              plugins: {
                                legend: { display: false },
                                tooltip: {
                                  backgroundColor: '#223843',
                                  padding: 10,
                                  cornerRadius: 6,
                                  callbacks: {
                                    label: (context) => {
                                      const total = activeStudentCount + inactiveStudentCount
                                      const value = Number(context.parsed) || 0
                                      const pct = total ? Math.round((value / total) * 100) : 0
                                      return ` ${context.label}: ${value} (${pct}%)`
                                    },
                                  },
                                },
                              },
                            }}
                          />
                          <div className="dash-doughnut-center">
                            <strong>{totalStudents}</strong>
                            <span>Total</span>
                          </div>
                        </div>
                        <div className="dash-legend">
                          <div className="dash-legend-item">
                            <span className="dash-swatch" style={{ background: '#223843' }} />
                            Active · {activeStudentCount}
                          </div>
                          <div className="dash-legend-item">
                            <span className="dash-swatch" style={{ background: '#10B981' }} />
                            Inactive · {inactiveStudentCount}
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="dash-empty">
                        <p>No student distribution data available.</p>
                        <p className="dash-empty-sub">Active and inactive student counts will appear here once students are enrolled.</p>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
              <Col xs={12} lg={7}>
                <div className="dash-panel h-100">
                  <div className="p-3 p-md-4">
                    <h5 className="dash-panel-title mb-3">Fees Collection By Months</h5>
                    <div style={{ height: '260px' }}>
                      {hasFeesCollectionData ? (
                        <Line data={data} options={options} />
                      ) : (
                        <div className="dash-empty">
                          <p>No fees collection data available.</p>
                          <p className="dash-empty-sub">Monthly fee collection amounts will appear here once payments are recorded.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="dash-panel">
              <div className="p-3 p-md-4">
                <h5 className="dash-panel-title mb-3">Total Students By Top Courses</h5>
                {countByCourse.length > 0 ? (
                  <div style={{ height: courseChartHeight }}>
                    <Bar data={courseChartData} options={courseChartOptions} plugins={[courseBarLabelPlugin]} />
                  </div>
                ) : (
                  <div className="dash-empty">
                    <p>No course data available.</p>
                  </div>
                )}
              </div>
            </div>
          </Container>
        </div>
      </div>
    </>
  )
}

